'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("budgetService", function ($http, $q, $session, $applications) {
  var budgets = null;
  var budgetMap = null;
  var budgetFetchPromise = null;
  var processServerBudgets = function processServerBudgets(serverBudget) {
    budgets = serverBudget;
    recomputeBudgetMap(budgets);
  };
  var recomputeBudgetMap = function recomputeBudgetMap(budgets) {
    budgetMap = {};
    if (!budgets) {
      return;
    }
    var _addToMap = function addToMap(budget) {
      budgetMap[budget.id] = budget;
      _.each(budget.children, function (child) {
        _addToMap(child);
      });
    };
    _.each(budgets, _addToMap);
  };
  var loadIfRequired = function loadIfRequired() {
    if (budgets != null) {
      return budgets;
    }
    if (budgetFetchPromise != null) {
      return budgetFetchPromise;
    }
    return doServerSync();
  };
  var doServerSync = function doServerSync() {
    var deferred = $q.defer();
    $http.get("/rest/budgets").then(function (response) {
      var budgets = response.data;
      processServerBudgets(budgets);
      deferred.resolve(budgets);
    });
    budgetFetchPromise = deferred.promise;
    return budgetFetchPromise;
  };
  return {
    $reload: function $reload() {
      return doServerSync();
    },
    $recompute: function $recompute() {
      recomputeBudgetMap(budgets);
    },
    /**
     * Par defaut uniquement les budgets non archivés, disponibles sur le module courant
     * @param config map optionnelle qui peut contenir {showArchive:true, showAllModules:true }
     *
     * @returns le graphe des budgets (donc les busgets racines comme liste)
     */
    findAll: function findAll(config) {
      // renvoie une copie pour protéger contre toute modification
      return $q.when(loadIfRequired()).then(function () {
        var budgetsAll = budgets.slice();
        if (!config || !config.showArchive === true) {
          budgetsAll = _.filter(budgetsAll, function (b) {
            return !b.archive;
          });
        }
        if (!config || config.showAllModules !== true) {
          budgetsAll = _.filter(budgetsAll, function (b) {
            return $applications.isAideSubventionApplication() && b.moduleSubvention || !$applications.isAideSubventionApplication() && b.moduleDette;
          });
        }
        return budgetsAll;
      });
    },
    /**
     *
     * @param budgetId
     * @returns {*} une promese à résoudre
     */
    findById: function findById(budgetId) {
      return $q.when(loadIfRequired()).then(function () {
        return budgetMap[budgetId];
      });
    },
    flattenTree: function flattenTree(budgets) {
      var flattened = [];
      var _appendSubTree = function appendSubTree(budget, depth) {
        var clone = _.extend(angular.copy(budget), {
          depth: depth
        });
        flattened.push(clone);
        if (budget.children && budget.children.length) {
          _.each(budget.children, function (children) {
            _appendSubTree(children, depth + 1);
          });
        }
      };
      _.each(budgets, function (budget) {
        _appendSubTree(budget, 0);
      });

      /**
       * idealement un tri MAIS par sous niveau
       flattened = flattened.sort(function (b1, b2) {
       let attrA = b1.nom.toLowerCase();
       let attrB = b2.nom.toLowerCase();
       return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
       });
       */

      return flattened;
    },
    getBudgetsForType: function getBudgetsForType(type) {
      return $http.get("/rest/budgets/type/" + type).then(function (response) {
        return response.data;
      });
    },
    isNommageBudget: function isNommageBudget() {
      return !$session.getCompte().budgetAsOperation;
    },
    isNommageOperation: function isNommageOperation() {
      return $session.getCompte().budgetAsOperation;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/budgetService.js
// module id = 2866
// module chunks = 13